import React, { useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSync, faCheck } from "@fortawesome/free-solid-svg-icons"
import CustomModal from "../../basics/interface/CustomModal"
import { COLORS } from "../../../utilities/Constants"

// Modale de consommation d'un article de stock virtuel.
// Étape 0 : choisir Rendre, Consommer ou Transférer (chef, si onTransferer
// fourni — ouvre le modal de transfert pré-rempli sur cet article).
// Étape 1 : rendre une quantité. Étape 2 : consommer sur un type de
// consommable.
const ConsoModalV2 = ({
	article,
	consommables,
	postState,
	onRendre,
	onConsommer,
	onTransferer,
	onClose,
}) => {
	const [step, setStep] = useState(0)
	const [quantite, setQuantite] = useState("")
	const [consommable, setConsommable] = useState(0)

	const max = article.quantite_recue - article.quantite_utilisee
	const busy = postState.saving || postState.saved

	const setQte = (value) => {
		if (value !== "" && parseInt(value) > max) setQuantite(String(max))
		else setQuantite(value)
	}

	const qteInvalide = ["", "0", 0].includes(quantite)

	// Boutons du footer selon l'étape.
	let buttons
	if (busy) {
		buttons = []
	} else if (step === 0) {
		buttons = [
			...(onTransferer
				? [
						{
							title: "Transférer",
							styleName: "secondary",
							onClick: onTransferer,
						},
					]
				: []),
			{
				title: "Rendre",
				styleName: "secondary",
				onClick: () => setStep(1),
			},
			{
				title: "Consommer",
				styleName: "primary",
				onClick: () => setStep(2),
			},
		]
	} else if (step === 1) {
		buttons = [
			{
				title: "Retour",
				styleName: "secondary",
				onClick: () => setStep(0),
			},
			{
				title: "Rendre",
				styleName: "primary",
				onClick: () => onRendre(article.id, quantite),
				disabled: qteInvalide,
			},
		]
	} else {
		buttons = [
			{
				title: "Retour",
				styleName: "secondary",
				onClick: () => setStep(0),
			},
			{
				title: "Consommer",
				styleName: "primary",
				onClick: () => onConsommer(consommable, article.id, quantite),
				disabled: consommable === 0 || qteInvalide,
			},
		]
	}

	return (
		<CustomModal
			title="Utiliser l'article"
			subtitle={article.label}
			onClose={onClose}
			showCloseButton={!busy}
			showFooter={!busy}
			buttons={buttons}
		>
			{busy ? (
				<div style={s.feedback}>
					{postState.saving ? (
						<FontAwesomeIcon icon={faSync} spin size="2x" />
					) : (
						<FontAwesomeIcon
							icon={faCheck}
							size="2x"
							style={{ color: COLORS.success }}
						/>
					)}
				</div>
			) : step === 0 ? (
				<div style={s.hint}>
					{onTransferer
						? "Rendre la pièce au fournisseur, la consommer ou la transférer dans le stock ?"
						: "Rendre la pièce au fournisseur ou la consommer ?"}
				</div>
			) : step === 1 ? (
				<div style={s.field}>
					<span style={s.label}>Quantité à rendre (max {max})</span>
					<input
						type="number"
						style={s.input}
						value={quantite}
						onFocus={(e) => e.target.select()}
						onChange={(e) => setQte(e.target.value)}
					/>
				</div>
			) : (
				<>
					<div style={s.field}>
						<span style={s.label}>Type</span>
						<select
							style={s.input}
							value={consommable}
							onChange={(e) =>
								setConsommable(parseInt(e.target.value))
							}
						>
							<option value={0}>-</option>
							{consommables.map((c) => (
								<option key={c.id} value={c.id}>
									{c.label}
								</option>
							))}
						</select>
					</div>
					<div style={s.field}>
						<span style={s.label}>Quantité (max {max})</span>
						<input
							type="number"
							style={s.input}
							value={quantite}
							onFocus={(e) => e.target.select()}
							onChange={(e) => setQte(e.target.value)}
						/>
					</div>
				</>
			)}
		</CustomModal>
	)
}

const s = {
	feedback: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		padding: "24px 0",
		color: COLORS.textMuted,
	},
	hint: { fontSize: 14, color: COLORS.textMuted, padding: "4px 0" },
	field: { display: "flex", flexDirection: "column", marginBottom: 14 },
	label: {
		fontSize: 12,
		fontWeight: 600,
		color: COLORS.textMuted,
		marginBottom: 6,
	},
	input: {
		height: 38,
		padding: "0 12px",
		borderRadius: 10,
		border: `1px solid ${COLORS.border}`,
		fontSize: 14,
		color: COLORS.text,
		fontFamily: "inherit",
		backgroundColor: COLORS.surface,
		boxSizing: "border-box",
	},
}

export default ConsoModalV2
